import { FC, useContext, useMemo } from "react";

import { StepTwoFormContext } from "../../../StepTwo/contexts";
import { StepThreeFormContext } from "../../contexts";

import { GenericDataFormContext, GroupedCoverageCardsList, QuotationInfoContext } from "../../../../../shared";
import { groupCardsByCommonSection, GroupedCoveragesCardsResult } from "../../../../../utils";
import { ContentSection } from "../../../../../../../../../shared/components";

interface CoveragesTheftInsuranceProps {
  tabKey: number;
}

export const CoveragesTheftInsurance: FC<CoveragesTheftInsuranceProps> = ({ tabKey }) => {

  const { stepThreeTheftInsuranceQuotationForm } = useContext( StepThreeFormContext );

   const { quotationInfo } = useContext( QuotationInfoContext );

  const { stepTwoForm } = useContext( StepTwoFormContext );

  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext( GenericDataFormContext );

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${ tabKey }`);

  const allCoveragesByTab = useMemo(() => allCoveragesPerPlan?.find( el => String(el.plan as string) === String(planSelected) )?.coverages, [ allCoveragesPerPlan, planSelected ]);

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult = useMemo(() => {
    return allCoveragesByTab 
      ? groupCardsByCommonSection(allCoveragesByTab, 'codigoFamilia')
      : {};
  }, [allCoveragesByTab]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>

      {/* Show ungrouped items first */}
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList 
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`theft-insurance-tab-${tabKey}-${planSelected}`}
              usedFormToCoverageCard={stepThreeTheftInsuranceQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          )
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList 
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`theft-insurance-tab-${tabKey}-${planSelected}`}
              usedFormToCoverageCard={stepThreeTheftInsuranceQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          )
        }
      })}
    </ContentSection>
  );
};